import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class GrupoDespesaService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getGruposDespesa(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/gruposdespesa' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getGrupoDespesa(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/gruposdespesa/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaGrupoDespesa(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/gruposdespesa', {
				grupo_despesa_nome: data.grupo_despesa_nome,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaGrupoDespesa(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/gruposdespesa/' + data.grupo_despesa_id, {
				grupo_despesa_nome: data.grupo_despesa_nome,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaGrupoDespesa(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/gruposdespesa/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
